import { createRouter, createWebHistory } from "vue-router";
import {
  storage,
  setTitle,
  getWxConfig,
  hideTitleBar,
  exitWindow,
} from "@/utils";
import { teacherInfoApi } from "@/api";
const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_APP_BASE_URL),
  routes: [
    {
      path: "/",
      name: "HomeIndex",
      redirect: "/meeting",
      component: () => import("@/views/meeting/index.vue"),
      meta: {
        // title: "小盒老师",
        title: "研修",
        showTab: true,
      },
    },
    {
      path: "/meeting",
      name: "MeetingIndex",
      component: () => import("@/views/meeting/index.vue"),
      meta: {
        // title: "小盒老师",
        title: "研修",
        showTab: true,
      },
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("@/views/login/index.vue"),
      meta: {
        title: "小盒老师",
      },
    },
    {
      path: "/meeting/search",
      name: "MeetingSearch",
      component: () => import("@/views/meeting/search/index.vue"),
      meta: {
        title: "搜索",
      },
    },
    {
      path: "/meeting/study",
      name: "MeetingStudy",
      component: () => import("@/views/meeting/study/index.vue"),
      meta: {
        title: "我的学习",
      },
    },
    {
      path: "/meeting/certs",
      name: "MeetingCerts",
      component: () => import("@/views/meeting/certs/index.vue"),
      meta: {
        title: "我的证书",
      },
    },
    {
      path: "/meeting/class-hour",
      name: "MeetingClassHour",
      component: () => import("@/views/meeting/class-hour/index.vue"),
      meta: {
        title: "学时记录",
      },
    },
    {
      path: "/meeting/cert-detail",
      name: "MeetingCertsDetail",
      component: () => import("@/views/meeting/certs/detail.vue"),
      meta: {
        title: "研修证书",
      },
    },
    {
      path: "/meeting/courses",
      name: "MeetingCourses",
      component: () => import("@/views/meeting/courses/index.vue"),
      meta: {
        title: "精彩直播",
      },
    },
    {
      path: "/meeting/packages-platform",
      name: "PackagesPlatform",
      component: () => import("@/views/meeting/packages-platform/index.vue"),
      meta: {
        title: "课程分类",
      },
    },
    {
      path: "/meeting/packages-local",
      name: "MeetingPackagesLocal",
      component: () => import("@/views/meeting/packages-local/index.vue"),
      meta: {
        title: "本地研修",
      },
    },
    {
      path: "/meeting/speakers",
      name: "MeetingSpeakers",
      component: () => import("@/views/meeting/speakers/index.vue"),
      meta: {
        title: "名师专区",
      },
    },
    {
      path: "/meeting/speakers/:id",
      name: "MeetingSpeakerDetail",
      component: () => import("@/views/meeting/speakers/detail.vue"),
      meta: {
        title: "名师主页",
      },
    },
    {
      path: "/meeting/package-detail/:id",
      name: "MeetingPackageDetail",
      component: () => import("@/views/meeting/package-detail/index.vue"),
      meta: {
        title: "课程详情",
      },
    },
    {
      path: "/meeting/package-detail-visitor/:id",
      name: "MeetingPackageDetailVisitor",
      component: () =>
        import("@/views/meeting/package-detail-visitor/index.vue"),
      meta: {
        title: "课程详情",
      },
    },
    {
      path: "/le-lessons",
      name: "LELessons",
      component: () => import("@/views/le-lessons/list/index.vue"),
      meta: {
        title: "听评课",
        showTab: false,
      },
    },
    // 讲课老师查看点评
    {
      path: "/le-lessons/result",
      name: "LELessonsResult",
      component: () => import("@/views/le-lessons/result/index.vue"),
      meta: {
        title: "点评",
        showTab: false,
      },
    },
    // 评课老师查看点评
    {
      path: "/le-lessons/evaluate-result",
      name: "LELessonsEvaluateResult",
      component: () => import("@/views/le-lessons/evaluate-result/index.vue"),
      meta: {
        title: "点评",
        showTab: false,
      },
    },
    {
      path: "/le-lessons/evaluate-lesson",
      name: "EvaulateLesson",
      component: () => import("@/views/le-lessons/evaluate-lesson/index.vue"),
      meta: {
        title: "点评",
        showTab: false,
      },
    },
    {
      path: "/le-lessons/evaluate-lesson-result",
      name: "EvaulateLessonResult",
      component: () =>
        import("@/views/le-lessons/evaluate-lesson-result/index.vue"),
      meta: {
        title: "简评",
        showTab: false,
      },
    },
    {
      path: "/invite-evaluate-lesson/:posterId",
      name: "InviteEvaulateLesson",
      component: () =>
        import("@/views/le-lessons/invite-evaluate-lesson/index.vue"),
      meta: {
        title: "评课邀请",
        showTab: false,
      },
    },
    {
      path: "/invite-evaluate-lesson-result/:posterId",
      name: "InviteEvaulateLessonResult",
      component: () =>
        import("@/views/le-lessons/invite-evaluate-lesson-result/index.vue"),
      meta: {
        title: "添加专属客服",
        showTab: false,
      },
    },
    {
      path: "/le-lessons/course-detail",
      name: "LELessonsDetail",
      component: () => import("@/views/le-lessons/course-detail/index.vue"),
      meta: {
        title: "课程详情",
        showTab: false,
      },
    },
    {
      path: "/personal-center",
      name: "PersonalCenter",
      component: () => import("@/views/personal-center/index.vue"),
      meta: {
        title: "个人中心",
        showTab: true,
      },
    },
    {
      path: "/personal-center/info",
      name: "PersonalCenterInfo",
      component: () => import("@/views/personal-center/information.vue"),
      meta: {
        title: "个人信息",
      },
    },
    {
      path: "/personal-center/improve-info",
      name: "PersonalCenterImproveInfo",
      component: () =>
        import("@/views/personal-center/improve-information.vue"),
      meta: {
        title: "完善信息",
      },
    },
    {
      path: "/app/jubao",
      name: "AppJubao",
      component: () => import("@/views/app/jubao/index.vue"),
      meta: {
        title: "匿名举报",
      },
    },
    {
      path: "/app/protocol",
      name: "AppProtocol",
      component: () => import("@/views/app/protocol/index.vue"),
      meta: {
        title: "协议详情",
      },
    },
    {
      path: "/404",
      name: "PageNotFound",
      component: () => import("@/views/404/index.vue"),
      meta: {
        title: "404",
      },
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/404",
    },
  ],
});
// 删除链接上指定参数
const removeUrlParams = async (to, param) => {
  if (to.query[param]) {
    const obj = {
      path: to.path,
      query: { ...to.query },
    };
    delete obj.query[param];
    if (to.query.source) {
      delete obj.query.source;
    }
    const arr = [];
    for (let key in obj.query) {
      arr.push(`${key}=${obj.query[key]}`);
    }
    if (arr.length > 0) {
      window.location.replace(`/tarc${to.path}?${arr.join("&")}`);
    } else {
      window.location.replace(`/tarc${to.path}`);
    }
    return true;
  }
  return false;
};
// 登录相关route name
const routesLogin = ["Login"];
// 不需要登录可以访问的页面
const onLoginRouters = [
  "MeetingPackageDetailVisitor",
  "InviteEvaulateLesson",
  "AppProtocol",
];
router.beforeEach(async (to, from, next) => {
  if (to.name === "AppProtocol") {
    // protocol兼容Andorid webview禁用storage缓存情况，localStorage、sessionStorage使用报错
    next();
    return;
  }
  if (window.__wxjs_environment === "miniprogram") {
    const { wxScene, scene } = to.query;
    if (wxScene) {
      // 小程序携带过来的自定义场景值
      storage.set("wxScene", wxScene);
    }

    if (scene) {
      // 小程序携带过来的自定义场景值
      storage.set("scene", scene);
    }

    const { uuid } = to.query;
    if (uuid) {
      // 小程序携带过来的uuid
      storage.set("uuid", uuid);
    }

    // 删除链接上的paperId
    if (to.query.paperId) {
      sessionStorage.setItem("paperId", to.query.paperId);
      const removeResult = await removeUrlParams(to, "paperId");
      if (removeResult) {
        return false;
      }
    }
    // 删除链接上的goLeLessons
    if (to.query.goLeLessons) {
      storage.remove("leATab");
      sessionStorage.setItem("goLeLessons", to.query.goLeLessons);
      const removeResult = await removeUrlParams(to, "goLeLessons");
      if (removeResult) {
        return false;
      }
    }
    // 删除链接上的evaluateListPaperId
    if (to.query.evaluateListPaperId) {
      sessionStorage.setItem(
        "evaluateListPaperId",
        to.query.evaluateListPaperId,
      );
      const removeResult = await removeUrlParams(to, "evaluateListPaperId");
      if (removeResult) {
        return false;
      }
    }
  }
  let { channel, token, source, version } = to.query;

  {
    // 兼容修复？携带多个key变成数组的情况
    if (Array.isArray(channel) && channel.length > 0) {
      channel = channel[0];
    } else {
      channel = channel || "";
    }
    if (Array.isArray(token) && token.length > 0) {
      token = token[0];
    } else {
      token = token || "";
    }
    if (Array.isArray(source) && source.length > 0) {
      source = source[0];
    } else {
      source = source || "";
    }
    if (Array.isArray(version) && version.length > 0) {
      version = version[0];
    } else {
      version = version || "";
    }
  }

  storage.set("channel", channel);
  if (source && token) {
    storage.set("token", token);
    storage.set("sourceDevice", source);
    if (version) {
      storage.set("version", version);
    }
    hideTitleBar();
  } else if (token) {
    storage.set("token", token);
  } else {
    token = storage.get("token");
  }

  if (onLoginRouters.includes(to.name)) {
    next();
    return;
  }

  // 删除链接上的token
  if (to.query.token) {
    const removeResult = await removeUrlParams(to, "token");
    if (removeResult) {
      return false;
    }
  }
  let sourceDevice = storage.get("sourceDevice");
  // 首页是个webview，不应该直接路由到首页
  if (sourceDevice && to.fullPath === "/meeting") {
    exitWindow();
  }
  // 钉钉、微信环境无需头部组件的设置title
  if (to.meta && to.meta.title) {
    setTitle(to.meta.title);
  }
  const kbUserInfo = localStorage.getItem("kb_userInfo");
  const userInfo = storage.get("userInfo");
  const { appId } = getWxConfig();

  if (token) {
    // 新版本教研会登陆后，旧版本页面打开免登录
    if (!kbUserInfo && !sourceDevice) {
      let obj = {
        openId: storage.get(`${appId}_openId`) || "",
        token,
        unionId: storage.get("unionId") || "",
      };
      localStorage.setItem("kb_userInfo", JSON.stringify(obj));
    }
    // 判断是否完善个人信息, app内首页点击任意一处验证
    if (!sourceDevice && (!userInfo || (userInfo && !userInfo.schoolId))) {
      // 从教研会海报h5过来会携带token，没有用户信息
      await getUserInfo(to, next);
    } else {
      // 已登录
      if (routesLogin.includes(to.name)) {
        // 打开登录相关页，直接跳首页
        next({
          path: "/",
          replace: true,
        });
      } else {
        // 正常打开页面
        next();
      }
    }
  } else {
    if (window.__wxjs_environment === "miniprogram") {
      const scene = storage.get("scene") || "";
      wx.miniProgram.reLaunch({
        url: `/pages/index/index?action=logout&scene=${scene}`,
      });
      return false;
    }
    // 未登录
    if (routesLogin.includes(to.name)) {
      // 正常打开登录相关页面
      next();
    } else {
      // 先跳登录页，登录成功后再回当前页
      const loginUrl = `login?next=${encodeURIComponent(window.location.href)}`;

      next(`/${loginUrl}`);
    }
  }
});
const getUserInfo = async (to, next) => {
  const res = await teacherInfoApi({}).catch((e) => e);
  if (res) {
    const { code, data } = res;
    if (code === 99999 && data) {
      if (next) {
        if (data.schoolId) {
          storage.set("userInfo", data);
          next();
        } else {
          if (to.name !== "PersonalCenterImproveInfo") {
            // 新用户打开小程序分享卡片
            if (
              to.query.fromShare &&
              window.__wxjs_environment === "miniprogram"
            ) {
              next({
                path: `/personal-center/improve-info`,
                query: { next: encodeURIComponent(window.location.href) },
                replace: true,
              });
            } else {
              next({
                path: "/personal-center/improve-info",
                replace: true,
              });
            }
          } else {
            next();
          }
        }
      }
    }
  }
};
export default router;
